import React from "react";
import { cn } from "@/utils/cn";

interface PageLayoutProps {
  children: React.ReactNode;
  className?: string;
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <div className={cn("h-full flex flex-col bg-gray-100 overflow-hidden", className)}>
      {children}
    </div>
  );
};
